import React, { useEffect, forwardRef } from "react";
import ConfigureMaskInput, { GeraDataMaskKey, AvaliableMaksType } from "../mask";
import InputBaseNormal from "~/components/InputBase/normal";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    mask?: AvaliableMaksType;
}

const InputNormal = forwardRef<React.FC, Props>(({ mask = "", ...props }, ref) => {
    const key = GeraDataMaskKey();

    useEffect(() => {
        /**
         * Configura as máscaras.
         */
        ConfigureMaskInput(mask as AvaliableMaksType, key);
    }, []);

    return (
        <>
            <InputBaseNormal //
                ref={ref}
                {...(mask ? { "data-mask-key": key } : {})}
                {...props}
            />
        </>
    );
});

export default InputNormal;
